<template>
    <div id="about" class="about-style-area with-black-color pt-100 pb-70">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="about-style-image-wrap">
                        <img src="../../assets/img/more-home/about/about-5.png" alt="image">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-style-wrap-content">
                        <span class="sub-title">About Our Company</span>
                        <h3>We Are Fully Dedicated To Support You</h3>
                        <p class="bold">Sed porttitor lectus nibh. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vivamus magna justo lacinia eget consectetur.</p>
                        
                        <div class="about-list-tab">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="about-1-tab" data-bs-toggle="tab" href="#about-1" role="tab" aria-controls="about-1">Our Mission</a>
                                </li>
        
                                <li class="nav-item">
                                    <a class="nav-link" id="about-2-tab" data-bs-toggle="tab" href="#about-2" role="tab" aria-controls="about-2">Our Vision </a>
                                </li>
                            </ul>
        
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="about-1" role="tabpanel">
                                    <div class="content">
                                        <p>Our plan dolor sit amet conseetur diisci velit sed quiLoresum dolor sit ame consectetur adipisicing elit.</p>

                                        <ul class="list">
                                            <li><i class='bx bx-chevrons-right'></i> Respect for all people</li>
                                            <li><i class='bx bx-chevrons-right'></i> Excellence in everything we do</li>
                                            <li><i class='bx bx-chevrons-right'></i> Truthfulness in our business</li>
                                        </ul>
                                        <div class="tab-btn">
                                            <a href="#" class="main-default-btn">Learn More</a>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="tab-pane fade" id="about-2" role="tabpanel">
                                    <div class="content">
                                        <p>Our plan dolor sit amet conseetur diisci velit sed quiLoresum dolor sit ame consectetur adipisicing elit.</p>

                                        <ul class="list">
                                            <li><i class='bx bx-chevrons-right'></i> Respect for all people</li>
                                            <li><i class='bx bx-chevrons-right'></i> Excellence in everything we do</li>
                                            <li><i class='bx bx-chevrons-right'></i> Truthfulness in our business</li>
                                        </ul>
                                        <div class="tab-btn">
                                            <a href="#" class="main-default-btn">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container pt-100">
            <div class="row justify-content-center">
                <div class="col-lg-3 col-sm-6">
                    <div class="information-card">
                        <div class="icon">
                            <i class='bx bx-time'></i>
                        </div>
                        <p>
                            <span>Mon-Fri (8am - 6pm)</span>
                            <span>Sat-Sun (10am - 2pm)</span>
                        </p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="information-card">
                        <div class="icon">
                            <i class='bx bxs-contact'></i>
                        </div>
                        <p>
                            <span>Contact us</span>
                            <span><a href="mailto:support@cavo.com">support@cavo.com</a></span>
                        </p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="information-card">
                        <div class="icon">
                            <i class='bx bx-phone-call'></i>
                        </div>
                        <p>
                            <span>(24 hours / 7 days)</span>
                            <span><a href="tel:4234543123678">+4 234-543 123 678</a></span>
                        </p>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="information-card">
                        <div class="icon">
                            <i class='bx bx-world'></i>
                        </div>
                        <p>
                            <span>9675 Grant Ave.</span>
                            <span>Chicago Heights, IL 60411</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'About'
}
</script>